export default () => {
  const $sectionTitles = $('.section-title');

  for (let i = 0; i < $sectionTitles.length; i += 1) {
    const $title = $($sectionTitles[i]);
    const parts = $title.text().split(' ');

    for (let j = 0; j < parts.length; j += 1) {
      const part = parts[j];

      if (part.length > 15) {
        $title.addClass('section-title--long');
        break;
      }
    }
  }
};
